import type Luminary from '@lumen5/luminary';

import type { LintFinding } from '../videoLinter';

import { TOOL_NAMES } from 'js/src/agent/toolNames';
import { MATCH_CUT } from 'js/src/agent/video-state/serialization/transitionDescription';
import { hasAppliedMatchCutWithNextScene } from 'js/src/luminary/luminary-selectors';
import { getMorphGapState } from 'js/src/luminary/morph-recommendation';

export const MAX_GAPS_LISTED = 5;

export function checkMatchCutOpportunities(luminary: Luminary): LintFinding[] {
    if (!luminary.template.transitionsEnabled) {
        return [];
    }
    if (luminary.scenes.some((scene) => hasAppliedMatchCutWithNextScene(scene))) {
        return [];
    }

    // The scenes a match cut could cut into. Matches the gap state TransitionSettingsPanel offers,
    // so lint won't flag a refused seam.
    const candidates = luminary.scenes.filter((scene) => {
        if (!scene.prevScene) {
            return false;
        }
        const gap = getMorphGapState(scene);
        return gap.isRecommended && !gap.isMorphEnabled;
    });
    if (candidates.length === 0) {
        return [];
    }

    const listed = candidates.slice(0, MAX_GAPS_LISTED);
    const sample =
        candidates.length > listed.length ? `, the first ${listed.length} of them listed here` : '';
    return [
        {
            check: 'match_cut_opportunities',
            severity: 'warning',
            sceneId: listed.map((scene) => scene.id),
            message: `No gap in this video carries a match cut, though ${candidates.length} could${sample}. Weigh the seam into each scene listed and call ${TOOL_NAMES.setSceneTransition} with transition "${MATCH_CUT}" where it earns its place. Leaving them all as plain cuts is a fine answer; not looking is not.`,
        },
    ];
}
